/** Date du jour au format YYYY-MM-DD (clé canonique pour les logs quotidiens) */
export const todayKey = (d: Date = new Date()): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Date longue en français (ex : "lundi 15 mai") */
export const formatDate = (d: Date | string): string => {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

/** Date courte (ex : "15/05/2026") */
export const formatShortDate = (d: Date | string): string => {
  const date = typeof d === 'string' ? new Date(d) : d;
  return date.toLocaleDateString('fr-FR');
};

/** Secondes → MM:SS (zéros à gauche, tabulaire) */
export const formatMmss = (totalSec: number): string => {
  const safe = Math.max(0, Math.floor(totalSec));
  const m = Math.floor(safe / 60);
  const s = safe % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};

/** Secondes → "1 min 30s" lisible */
export const formatDurationHuman = (totalSec: number): string => {
  if (totalSec < 60) return `${totalSec}s`;
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return s ? `${m} min ${s}s` : `${m} min`;
};

/** Lien YouTube de recherche pour la démo d'un exercice */
export const ytSearchUrl = (q: string): string =>
  `https://www.youtube.com/results?search_query=${encodeURIComponent(q + ' tutorial form')}`;

/** Lien MuscleWiki de recherche */
export const mwSearchUrl = (q: string): string =>
  `https://musclewiki.com/search?query=${encodeURIComponent(q)}`;
